















import Vue, { PropType } from "vue";
import "@/components/icons";
import PlanFloatingView from "../PlanFloatingView/index.vue";

import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "CreatePlanFloatingView",
  components: {
    PlanFloatingView
  },
  props: {
    availableGraduateYears: {
      type: Array as PropType<Props["availableGraduateYears"]>,
      required: true
    },
    messages: {
      type: Array as PropType<Props["messages"]>,
      required: true
    }
  },
  data() {
    return {
      newPlan: {
        name: "",
        graduateYear: Number(this.availableGraduateYears[0].label)
      }
    };
  },
  computed: {
    disabledSubmitButton() {
      return false;
      // TODO: フロントでのエラーハンドリングが出来ていないため、不活性化はしない
      // return !this.newPlan.name;
    }
  },
  methods: {
    handleSelectYearValue(graduateYear) {
      this.newPlan.graduateYear = graduateYear;
    },
    handleChangeName(name) {
      this.newPlan.name = name;
    },
    handleClickCreateFloatingViewClose() {
      this.$emit("close");
    },
    handleCreatePlan() {
      this.$emit("click", this.newPlan.name, this.newPlan.graduateYear);
    }
  }
});
